export const getDisplayPrice = (item, isUpsell = false) => {
  let amount;
  // if there is a fee
  if (item.unitThirdPartyFee > 0) {
    if (item.hiddenFee) {
      if (item.combinedDiscount > 0) {
        amount = item.unitPriceWithDiscountAndFeeIfHidden;
      } else {
        amount = item.unitPriceWithUnitFeeIfHidden;
      }
    } else {
      if (item.combinedDiscount > 0) {
        if (isUpsell) {
          amount = item.unitPriceAndFee - item.combinedDiscount;
        } else {
          amount = item.listPrice - item.combinedDiscount;
        }
      } else {
        if (isUpsell) {
          amount = item.unitPriceAndFee;
        } else {
          amount = item.listPrice;
        }
      }
    }
  }
  // if there's no fees
  else {
    if (item.combinedDiscount > 0) {
      amount = item.listPrice - item.combinedDiscount;
    } else {
      amount = item.listPrice;
    }
  }
  return amount;
};

export const getOrigPrice = (item, isUpsell = false) => {
  let amount;
  // if there is a fee
  if (item.unitThirdPartyFee > 0) {
    if (item.hiddenFee) {
      amount = item.unitPriceAndFee;
    } else {
      if (isUpsell) {
        amount = item.unitPriceAndFee;
      } else {
        amount = item.listPrice;
      }
    }
  }
  // if there's no fees
  else {
    amount = item.listPrice;
  }
  return amount;
};

export const getUpsellTotal = (upsells) => {
  // we are excluding any selected replace upsell from the calculations
  // when an upsellType=Replace upsell is marked as selected it means that the main product is itself
  // this also means that the replace upsell price is alreday included in the main item's price
  return upsells
    .filter((upsell) => upsell.isSelected && upsell.upsellType !== 'Replace')
    .reduce((acc, cur) => {
      return acc + (cur.listPrice + cur.unitThirdPartyFee - cur.combinedDiscount) * cur.quantity;
    }, 0);
};
